import { styled } from '@components-shared/src/stitches';

export const CarouselContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '$4',

  variants: {
    noGap: {
      true: {
        gap: 0,
      },
    },
  },
});

export const Header = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

export const PlaylistInfo = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  base: 'M',
  fontWeight: 500,
  color: '$neutral500',
  h3: {
    title: 'M',
    // make sure text is visible above fade
    zIndex: '$base',
  },
  '@tablet': {
    base: 'L',
    h3: {
      title: 'L',
    },
  },
});
